import { Controller } from "react-hook-form";
import React, {FC} from "react";
import {TextArea} from "../../../../../components/TextArea";
import {OTHER_VALUE} from "../../const";

interface Props {
    control: any;
}

const OtherFields: FC<Props> = ({control}) => {

    return (
        <>
            <Controller
                render={({ field, fieldState }) => {
                    return (
                        <TextArea
                            placeholder="Комментарий"
                            {...field}
                            {...fieldState}
                            ref={null}
                        />
                    );
                }}
                name={`${OTHER_VALUE}.comment`}
                control={control}
            />
        </>
    );
};

export default OtherFields;
